import { render, staticRenderFns } from "./user-view-dialog.vue?vue&type=template&id=7f88e48e&"
import script from "./user-view-dialog.vue?vue&type=script&lang=js&"
export * from "./user-view-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports